import {
  applyAppInsightsConsent,
  getConsent,
  initializeConsent,
  loadMouseflow,
} from '@city-sage/aurum-avis-labs-components';
import {
  applyConsentChoice,
  loadTravelpayouts,
  type ConsentScriptChoice,
} from './consent-scripts';
import { syncGtmWithConsent } from './gtm';

function applyRuntimeConsent(consent: ConsentScriptChoice | null): void {
  applyConsentChoice(consent, {
    syncGtm: (choice) => syncGtmWithConsent(choice),
    applyAppInsights: (enabled) =>
      applyAppInsightsConsent(
        enabled,
        import.meta.env.VITE_AZURE_APPINSIGHTS_CONNECTION_STRING
      ),
    loadMouseflow: () => {
      if (import.meta.env.DEV) return;
      const projectId = import.meta.env.VITE_MOUSEFLOW_PROJECT_ID as
        | string
        | undefined;
      if (projectId) {
        loadMouseflow(projectId);
      }
    },
    loadTravelpayouts: () => loadTravelpayouts(),
  });
}

initializeConsent();
applyRuntimeConsent(getConsent());

window.addEventListener('consentUpdated', (event: Event) => {
  const detail = (event as CustomEvent<ConsentScriptChoice | null>).detail;
  applyRuntimeConsent(detail ?? null);
});
